const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDutch = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 250.000000 250.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,250.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1130 2494 c-367 -47 -666 -215 -876 -493 -62 -82 -174 -286 -174 -317 0 -12 167 -14 1170 -14 1003 0 1170 2 1170 14 0 8 -25 63 -55 123 -172 342 -477 579 -855 664 -83 18 -308 32 -380 23z",
    style: {
      fill: "#21468B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 817 c0 -7 24 -62 54 -122 173 -349 497 -595 883 -672 119 -23 347 -23 466 0 386 77 710 323 883 672 30 60 54 115 54 122 0 11 -228 13 -1170 13 -942 0 -1170 -2 -1170 -13z",
    style: {
      fill: "#AE1C28"
    }
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDutch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dutch.dee68cee.svg";
export { ForwardRef as ReactComponent };